"use strict";
var Observable_1 = require('../../Observable');
var of_1 = require('../../observable/of');
Observable_1.Observable.of = of_1.of;
//# sourceMappingURL=of.js.map


//////////////////
// WEBPACK FOOTER
// d:/xampp/htdocs/zenith-admin/~/rxjs/add/observable/of.js
// module id = ../../../../rxjs/add/observable/of.js
// module chunks = 4